import { render, staticRenderFns } from "./Planing.vue?vue&type=template&id=73086a98&"
import script from "./Planing.vue?vue&type=script&lang=ts&"
export * from "./Planing.vue?vue&type=script&lang=ts&"
import style0 from "./Planing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports